import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-content'>
        <span>
          © 2024 <span>JERNEJ JAKOP</span>
        </span>
        <a href='#top'>BACK TO TOP</a>
      </div>
    </footer>
  );
};

export default Footer;
